module.exports = __webpack_public_path__ + "61d096b8b812735a616e114fff2b2c83.png";